"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const browser_logs_1 = require("@datadog/browser-logs");
const formatPinoBrowserLogEvent_js_1 = require("../formatPinoBrowserLogEvent.js");
const defaults = {
    forwardConsoleLogs: [],
    forwardErrorsToLogs: true,
    trackSessionAcrossSubdomains: true,
    useSecureSessionCookie: true,
    useCrossSiteSessionCookie: true,
    sessionSampleRate: 100
};
let initialized = false;
const createBrowserPinoSend = (options) => {
    const { name } = options;
    // Prevent datadog from being initialized more than once.
    // This can happen in dev when pages are hot-reloaded.
    if (!initialized) {
        browser_logs_1.datadogLogs.init({
            ...defaults,
            ...options
        });
        initialized = true;
    }
    let logger;
    /* istanbul ignore next */
    if (name) {
        logger = browser_logs_1.datadogLogs.createLogger(name);
    }
    else {
        logger = browser_logs_1.datadogLogs.logger;
    }
    /* istanbul ignore next */
    return (level, logEvent) => {
        // extract message, data and bindings from logEvent
        const message = (0, formatPinoBrowserLogEvent_js_1.formatPinoBrowserLogEvent)(logEvent);
        // Send the log event to Datadog
        switch (level) {
            case 'info':
                logger.info(message.log_entry, message.metadata);
                break;
            case 'warn':
                logger.warn(message.log_entry, message.metadata);
                break;
            case 'error':
                logger.error(message.log_entry, message.metadata);
                break;
            case 'debug':
                logger.debug(message.log_entry, message.metadata);
                break;
            default:
                logger.info(message.log_entry, message.metadata);
        }
        logger.info(message.log_entry, message.metadata);
    };
};
exports.default = createBrowserPinoSend;
//# sourceMappingURL=datadogPino.js.map